import { enqueueSnackbar } from "notistack";
import {
  OWNER_FILE_UPLOAD_FAILURE,
  OWNER_FILE_UPLOAD_REQUEST,
  OWNER_FILE_UPLOAD_SUCCESS,
} from "../constants";
import { postAuthenticationRequest } from "../../../services/apiManager/apiRequests";
import apiConfig from "../../../services/apiManager/apiConfig";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const ownerFileUploadRequest =
  (uploadedDL, documentType, userId, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: OWNER_FILE_UPLOAD_REQUEST,
        payload: { isLoading: true },
      });
      const formData = new FormData();
      formData.append(
        "preValidatedMetadata",
        JSON.stringify({
          visibility: "PRIVATE",
          lifespan: "PERMANENT",
        }),
      );
      formData.append(
        "fileInfos",
        JSON.stringify([
          {
            name: "file0",
            mediaType:
              uploadedDL?.type === "application/pdf" ? "PDF" : uploadedDL?.type,
            mediaCode: documentType,
          },
        ]),
      );
      formData.append("uploadType", "DOCUMENT");
      formData.append("entityType", "SAFE_TRUCK_PARKING");
      formData.append("file0", uploadedDL);
      // formData.append("file1", uploadedInsurance);
      formData.append("userId", userId);
      // }
      const response = await postAuthenticationRequest(
        apiConfig.ownerFileUpload,
        formData,
        null,
        null,
        "multipart/form-data",
      );
      if (response?.statuscode === 200) {
        dispatch({
          type: OWNER_FILE_UPLOAD_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: OWNER_FILE_UPLOAD_FAILURE,
          payload: { isLoading: false },
        });
        callback({});
      }
      dispatch({
        type: OWNER_FILE_UPLOAD_FAILURE,
        payload: { isLoading: false },
      });
    } catch (error) {
      callback({});
      if (error?.response?.data?.errMsg) {
        enqueueSnackbar(error?.response?.data?.errMsg, {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: OWNER_FILE_UPLOAD_FAILURE,
        payload: { isLoading: false },
      });
    }
  };
